/* FIXME: This file will need to implement translations once the useDashboardReskinExperiment is implemented outside the US */
import type { JSX } from 'react';

import { CheckIcon, LinkIcon } from '@change/ds-icons';

import { Button, Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { useCopyLinkButtonReskin } from 'src/app/pages/starterDashboardV2/shared/hooks';

type CopyLinkButtonProps = {
	shareUrl: string;
};

export function CopyLinkButton({ shareUrl }: CopyLinkButtonProps): JSX.Element {
	const { data, actions } = useCopyLinkButtonReskin({ shareUrl });

	return (
		<Button
			data-testid="copy-link-share-button"
			data-qa="copy-link-share-button"
			variant="secondary"
			size="small"
			leadingIcon={
				data.copied ? (
					<CheckIcon
						data-testid="copy-link-icon-success"
						data-qa="copy-link-icon"
						aria-label="Link Copied"
						className="text-icon-success"
					/>
				) : (
					<LinkIcon
						data-testid="copy-link-icon"
						data-qa="copy-link-icon"
						aria-label="Copy Link"
						className="text-typography-strong"
					/>
				)
			}
			className="text-typography-strong bg-fill-inverse-strong flex w-full items-center justify-center gap-1.5 px-3 py-2"
			as="a"
			onClick={actions.handleShare}
		>
			{data.copied ? (
				<Translate value="corgi.petition.starter_dashboard.grow_petition.copy_link.copy_success" />
			) : (
				<Text fontWeight="bold" className="leading-5">
					<Translate value="corgi.petition.starter_dashboard.grow_petition.copy_link.copy_button" />
				</Text>
			)}
		</Button>
	);
}
